import { SectorModel } from './../../service/sector.model';
import { Router } from '@angular/router';
import { TrainService } from './../../service/train.service';
import { DBConnectorService } from './../../service/test.service';
import { DropzoneComponent, DropzoneConfigInterface, DROPZONE_CONFIG, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, Subscription, interval } from 'rxjs';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ShowLogDialogComponent } from '../../show-log-dialog/show-log-dialog.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-step2newdata',
  templateUrl: './step2newdata.component.html',
  styleUrls: ['./step2newdata.component.css']
})
export class Step2newdataComponent implements OnInit, OnDestroy {
  bsModalRef: BsModalRef;
  Status: string;
  @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;
  enableGetLogs: boolean;
  sectormodel = new SectorModel;
  firstClick: boolean;
  labelname = [];
  result:any = {};
  addedItem = [];
  click = true;
  sub: Subscription;

  public config: DropzoneConfigInterface = {
    url: '/api/TrainNew/SaveUploadedFileNew',
    clickable: true,
    headers: {
      'Sector': this.dbconnectorservice.SectorName,
      'Model': this.dbconnectorservice.ModelName
    },
    uploadMultiple: true,
    parallelUploads: 3,
    autoReset: null,
    errorReset: 15000,
    cancelReset: 15000,
    createImageThumbnails: true,
    dictDefaultMessage: 'Drag and Drop or Click to browse for files',
    acceptedFiles: '.xlsm,.xlsx',

  };

  constructor(private dbconnectorservice: DBConnectorService,
    private trainservice: TrainService,
    private http: HttpClient,
    private router: Router,
    private loggedInGuard: LoggedInGuard,
    private _dialogService: BsModalService
    ) {

    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.sectormodel.User = this.dbconnectorservice.username;
    this.configset();
  }
  configset() {

    const url1 = '/api/TrainNew/SaveUploadedFileNew';
    // const resource = this.adalService.GetResourceForEndpoint(url1);
    // const token = this.adalService.getCachedToken(resource);
    // const tokenbearer = 'Bearer ' + token;

    this.config = {
      url: url1,
      clickable: true,
      headers: {
        'Authorization': this.dbconnectorservice.getToken(url1),
        'Sector': this.dbconnectorservice.SectorName,
        'Model': this.dbconnectorservice.ModelName
      },
      uploadMultiple: true,
      parallelUploads: 3,
      autoReset: null,
      errorReset: 15000,
      cancelReset: 15000,
      createImageThumbnails: true,
      dictDefaultMessage: 'Drag and Drop or Click to browse for files',
      acceptedFiles: '.xlsm,.xlsx',
      timeout: 240000

    };
  }

  onUploadError(args: any) {
    // console.log('onUploadError:', args);
  }
  onUploadSuccess(args: any) {
    // console.log('onUploadSuccess:', args);
    this.result = args[1];
  }

  AddFunction() {
    this.addedItem.push(
      {
        'SheetName': '',
        'ColumnName': '',
        'LabelName': '',

      }
    );

  }
  removeFunction(i: number) {
    this.addedItem.splice(i, 1);
  }

  Dbinsert() {

    const data = {
      'Sector': this.dbconnectorservice.SectorName,
      'Model': this.dbconnectorservice.ModelName,
      'Desc': this.addedItem
    };

    this.trainservice.LabelMapping(data)
      .subscribe(
        (data) => {
          // console.log('data '+data);
        });
    // console.log(' data ' + JSON.stringify(data));
    alert('Changes Applied');
  }

  // FileUpload
  fileChange(event: any) {
    alert('Uploading Files');
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      console.log(fileList);
      for (var i in fileList) {
        let file: File = fileList[i];
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        // console.log(formData);

        let options = {
          headers: new HttpHeaders({
            'Accept': 'application/json',
            'Sector': this.dbconnectorservice.SectorName,
            'Model': this.dbconnectorservice.ModelName
          })
        }
        //let options = new RequestOptions({ headers: headers });
        let apiUrl = '/api/TrainNew/SaveUploadedFileNew';
        this.http.post<any>(apiUrl, formData, options)
          // .catch(error => Observable.throw(error))
          .subscribe(
            data => {
              console.log('Files uploaded');
            }
            // error => console.log('error');
          )
      }
      alert('Files Uploaded');
    }
  }

  preprocessNew() {
    if (this.loggedInGuard.isSessionValid()) {
      console.log('Preprocess - start');
      this.enableGetLogs = true;
      this.click = false;
      this.firstClick = true;
      this.trainservice.PreprocessNew(this.sectormodel)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            console.log('Preprocess - after api');
            // if (data['Preprocess']) {
            //   this.router.navigate(['Train/Step3NewData']);
            // }
          });
    }
  }

  redirect() {
    this.router.navigate(['Home/Update']);
  }

  CancelTrain() {

    this.trainservice.cancelTrain(this.sectormodel)
      .subscribe(
        (data) => { });
  }

  StatusCheck() {
    this.trainservice.statusCheck(this.sectormodel)
      .subscribe(
        (data) => {
          this.Status = data;
          if (this.Status === 'PROCESSING NEW') {
            this.click = false;
            this.enableGetLogs = true;
          } else if (this.Status === 'PROCESSED' && this.click === false) {
            this.router.navigate(['Train/Step3NewData']);
          } else {
            this.click = true;
          }
          console.log(this.Status);
        });

  }

  ngOnInit() {

    this.addedItem = [];
    this.trainservice.getLabelMapping(this.sectormodel)
      .subscribe(
        (data) => {
          // console.log('data '+data);
          this.addedItem = data;
        });

    this.trainservice.getLabelName(this.sectormodel)
      .subscribe(
        (data) => {
          // console.log(data['labelname']);
          this.labelname = data['labelname'];
        });

    this.StatusCheck();

    this.sub = interval(5000).subscribe(x => {
      if (this.click === false && this.firstClick === true) {
        setTimeout(()=>{
          this.StatusCheck();
          this.firstClick = false;
        }, 20000);
        
      }
      else if (this.click === false) {
        this.StatusCheck();
      }

    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  OpenLogsDialog() {
    console.log("clicked!")
    const initialState = {
      source: "preprocess_new",
      username: this.sectormodel.User
    };
    this.bsModalRef = this._dialogService.show(ShowLogDialogComponent, { initialState })
    //this._dialogService.addDialog(ShowLogDialogComponent, { source: "preprocess_new", username: this.sectormodel.User }).subscribe(data => console.log(data))
  }

}
